<template>
  <div class="pagenation">
    <router-link class="ar prev" :to="{ path: path, query : prevCondition }" v-if="prev"></router-link>
    <span class="ar prev" v-else></span>
    <ul class="inner">
      <li class="num" v-for="(item, index) in pageList" :key="index" :class="page == item.page ? 'on' : ''">
        <router-link :to="{ path: path, query : pageCondition(item.page) }">
          {{ item.page }}
        </router-link>
      </li>
    </ul>
    <router-link class="ar next" :to="{ path: path, query : nextCondition }" v-if="next"></router-link>
    <span class="ar next" v-else></span>
  </div>
</template>

<script>
  import _ from 'lodash'

  export default {
    name: "pagination",
    props: [
      'totalCount',
      'pageSize',
      'page',
      'condition'
    ],
    data() {
      return {
        visible: false,
        perLinks: 10,
        pageName: 'page',
        first: '',
        last: '',
        prev: '',
        next: '',
        pageList: [],
        pages: '',
        Offset: '',
        skip: '',
        index: 0,
        baseUrl: this.$route.path,
        start: 0,
        path: this.$route.path,
        f: this.$route.query.f,
        k: this.$route.query.k,
      }
    },
    created() {
      this.getPages();
    },
    methods: {
      getPages() {
        let page = this.page;
        let totalCount = this.totalCount;

        if (page < 1) {
          page = 1;
        }

        if (totalCount < 1) {
          totalCount = 1;
        }

        if (this.perLinks < 1) {
          this.perLinks = totalCount + 1;
        }

        if (parseInt(this.pageSize) <= 0) {
          this.pageSize = 20;
        }

        /*--------  전체 페이지 수 구하기 --------*/
        this.pages = parseInt(totalCount / this.pageSize);

        // 전체 페이지 수가 1보다 작은 경우 전체 페이지수는 1개
        if (this.pages < 1) {
          this.pages = 1;
        }

        // 마지막 페이지의 게시물 수의 나머지 값이 있는 경우 전체 페이지 수 증가
        if ((totalCount > this.pageSize) && (totalCount % this.pageSize) > 0) {
          this.pages += 1;
        }

        // 전체 게시물 수가 없는 경우 현재 페이지는 1page
        if (totalCount < 1 || page < 1) {
          page = 1;
        } else if (page > this.pages) {
          // 전체 페이지수를 넘는 경우
          page = this.pages;
        }

        //baseUrl
        this.baseUrl = this.baseUrl + '?';

        /*--------  Offset 구하기 --------*/
        this.start = (page - 1) * this.pageSize;

        /*--------  처음, 마지막 페이지 구하기 --------*/
        if (this.pages > this.perLinks) {
          if (page > this.perLinks) {
            // 처음 페이지
            this.first = 1;
          }
          if ((this.pages - page) > this.perLinks) {
            //마지막 페이지
            this.last = this.pages;
          }
        }

        // 처음 페이지
        if (page > 0 && totalCount > this.pageSize) {
          this.first = 1;
        }

        //마지막 페이지
        if ((this.pages - page) > 0 && totalCount > this.pageSize) {
          this.last = this.pages;
        }

        // 이전 페이지
        this.prev = (page - 1);

        // 다음 페이지
        this.next = '';
        if (page + 1 <= this.pages) {
          this.next = (page + 1);
        }

        this.nInspire = ((parseInt((page - 1) / this.perLinks)) * this.perLinks) + 1;
        if (this.nInspire < 1) {
          this.nInspire = 1;
        }

        this.nExpire = this.nInspire + this.perLinks - 1;
        if (this.nExpire >= this.pages) {
          this.nExpire = this.pages;
        }

        this.pageList = [];
        for (this.nIndex = this.nInspire; this.nIndex <= this.nExpire; this.nIndex++) {
          this.pageList.push({
            url: this.baseUrl + this.queryString,
            page: this.nIndex
          });
        }

        this.index = totalCount - this.start;

      },
      getLink(page) {
        this.$eventBus.$emit("getList", page);
      },
      pageCondition(page){
        return _.merge({ page: page }, this.condition)
      }
    },
    computed: {
      prevCondition() {
        return _.merge( { page: this.prev }, this.condition )
      },
      nextCondition() {
        return _.merge( { page: this.next }, this.condition )
      }
    },
    watch: {
      totalCount(to, from) {
        this.getPages();
      },
      page(to, from) {
        this.getPages();
      }
    }
  }

</script>



// WEBPACK FOOTER //
// src/components/pagenation.vue